module.exports = "dist/images/components-design-separator-control-curve-3.b42e517.png";